import { useEffect, useState } from "react";
import DialogModal from "components/UI/DialogModals";
import MaskedField from "components/UI/Fields/MaskedField";
import { MeasurementStore } from "store";
import { lang } from "i18nLang";

const MeasurementReadjustment = ({ open, onClose }) => {
  const measurement = MeasurementStore.currentMeasurement;
  const [readjust, setReadjust] = useState(0);

  useEffect(() => {
    if (open && measurement) {
      setReadjust(measurement.readjustValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleChange = (ev) => {
    const { value } = ev.target;
    setReadjust(value);
  };

  const handleConfirm = () => {
    MeasurementStore.updateMeasurementReadjustment(readjust);
  };

  return (
    <DialogModal
      title={lang("measurementReadjustment.title")}
      open={open}
      confirmLabel={lang("save")}
      disabledConfirm={!measurement?.canEdit()}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <MaskedField
        name="readjust"
        label={lang("measurementReadjustment.readjust")}
        prefix={lang("currency")}
        decimalScale={2}
        fixedDecimalScale={true}
        allowNegative={false}
        value={readjust}
        onChange={handleChange}
        onKeyDown={(ev) => ev.stopPropagation()}
        margin="normal"
        fullWidth
      />
    </DialogModal>
  );
};

export default MeasurementReadjustment;
